import React from "react";
import "./FormFieldsTable.scss";

const FormFieldsTable = (props) => {

  return (
    <table className="FormFieldsTable">
      <tbody>
        {props.children}
      </tbody>
    </table>
  )

}


export default FormFieldsTable;